module.exports = __webpack_public_path__ + "img/hamburger-close.b1900c15.svg";